import { render, staticRenderFns } from "./Thumb.vue?vue&type=template&id=4f36016a"
import script from "./Thumb.vue?vue&type=script&lang=js"
export * from "./Thumb.vue?vue&type=script&lang=js"
import style0 from "./Thumb.vue?vue&type=style&index=0&id=4f36016a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports